import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactDOM from 'react-dom';
import { Provider, connect } from 'react-redux';
import ReactHighcharts from 'react-highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import numeral from 'numeral';
import { Tooltip, OverlayTrigger, Dropdown, MenuItem } from 'react-bootstrap';
import {
  each, indexOf, uniq, filter, sortBy, sum, slice, reduce, keys,
  min, max,
} from 'lodash';
import Fa from 'react-fontawesome';
import ProgressBar from '../../../../components/progress-bar';

import styles from './styles.css';
import MoneyDisplay, { format as formatMoney } from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';
import OwnerCell from '../../../../components/owner-cell';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getIsFontSizeBig } from '../../../App/AppReducer';

// Import Selectors
import { getSaleReps, getLoaded } from '../../PerformanceReducer';
import { getHasDealTypeSetup } from '../../../../components/search-form/search-form-reducer';
import { fetchForecast } from '../../PerformanceActions';

import { getColorFromKey } from '../../../../util/helpers';

if (typeof window !== 'undefined') {
  highchartsMore(ReactHighcharts.Highcharts);
}
const USER_PREFERENCE_RATE_TYPE = 'performance-quadrant-rate-type';
const USER_PREFERENCE_DEAL_TYPE = 'performance-quadrant-deal-type';
const USER_PREFERENCE_REPORT_TYPE = 'performance-quadrant-report-type';
const USER_PREFERENCE_SHOW_TIP = 'performance-quadrant-show-tip';
const USER_PREFERENCE_IS_FIXED = 'performance-quadrant-is-fixed';

function formatGap(input, reverse = false) {
  const prefix = input > 0 ? '+' : '';
  const format = input !== 0 ? '0.0' : 0;
  let cls = '';
  if (input >= 0) {
    cls = reverse ? 'label-danger' : 'label-success';
  } else {
    cls = reverse ? 'label-success' : 'label-danger';
  }
  return `<span class="label ${cls}">${prefix}${numeral(input).format(format)}%</span>`;
}

class Quadrant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 'Won', // Won, Lost, No Decision,
      statType: 'amount', // 'amount', 'count'
      showTooltip: false,
      dealType: null,
      hasData: false,
      stageWithDealTypes: {},
      // loadingForecast: props.displayForecastData, // init
      loadingForecast: false,
      period: null,
      forecastCategoryParams: null,
      forecastMappingLabels: [],
      periodLabel: null,
      isFixed: false, // https://github.com/lumen-software/TruSales/issues/1192
    };

    this.handleShowTooltip = this.handleShowTooltip.bind(this);
    this.handleIsFixedQuarants = this.handleIsFixedQuarants.bind(this);
    this.toggleDealType = this.toggleDealType.bind(this);
    this.toggleStatType = this.toggleStatType.bind(this);
    this.toggleStage = this.toggleStage.bind(this);
    this.handleForecastParamChange = this.handleForecastParamChange.bind(this);
  }

  componentWillMount() {
    const { userPreferences } = this.context;

    const stage = userPreferences[USER_PREFERENCE_RATE_TYPE] || 'Won';
    const dealType = userPreferences[USER_PREFERENCE_DEAL_TYPE] || null;
    const statType = userPreferences[USER_PREFERENCE_REPORT_TYPE] || 'amount';
    const showTooltip = userPreferences[USER_PREFERENCE_SHOW_TIP] || false;
    const isFixed = userPreferences[USER_PREFERENCE_IS_FIXED] || false;

    this.setState({ showTooltip, statType, dealType, stage, isFixed });
  }

  componentDidMount() {
    this.checkState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.checkState(nextProps);
  }

  getAverage(inputs) {
    const { length } = inputs;
    if (length === 0) {
      return 0;
    }
    return sum(inputs) / length;
  }

  getLabel(stage, suffix = 'Rate') {
    let label = stage;
    if (stage === 'forecast') {
      label = 'Forecast Accuracy';
    } else if (stage === 'Won') {
      label = `Win ${suffix}`;
    } else if (stage === 'Lost') {
      label = `Loss ${suffix}`;
    } else {
      label = `${label} ${suffix}`;
    }
    return label;
  }

  getOrderTypes() {
    return ['All', 'Renewal', 'New business', 'Add-on', 'Upsell'];
  }

  handleForecastParamChange(period, forecastCategoryParams, periodLabel, forecastMappingLabels) {
    this.setState({
      period, forecastCategoryParams, periodLabel, forecastMappingLabels,
    }); // remember this, for chart segment click events
    const {
      criteria, minForecastDate, maxForecastDate, forecastKey,
    } = this.props;
    const params = {
      ...criteria,
      selectedPeriod: period,
      forecast: true,
      period: [minForecastDate, maxForecastDate],
    };
    this.setState({ loadingForecast: true });
    this.props.dispatch(fetchForecast(params, forecastCategoryParams, forecastKey))
      .then(
        () => {
          this.setState({ loadingForecast: false });
        },
        () => {
          this.setState({ loadingForecast: false });
        },
      );
  }

  checkState(props) {
    const { saleReps } = props;
    let stageWithDealTypes = {};
    each(saleReps, (saleRep) => {
      each(saleRep.items, (item) => {
        const itemStage = item.stage;

        if (!stageWithDealTypes[itemStage]) {
          stageWithDealTypes[itemStage] = {};
        }
        if (!stageWithDealTypes.forecast) {
          stageWithDealTypes.forecast = {};
        }
        each(item.types, (t) => {
          if (!stageWithDealTypes[itemStage][t]) {
            stageWithDealTypes[itemStage][t] = [];
          }
          if (!stageWithDealTypes.forecast[t]) {
            stageWithDealTypes.forecast[t] = [];
          }
          stageWithDealTypes[itemStage][t].push(item.owner_id);
          stageWithDealTypes.forecast[t].push(item.owner_id);
        });
        if (!stageWithDealTypes[itemStage].All) {
          stageWithDealTypes[itemStage].All = [];
        }
        if (!stageWithDealTypes.forecast.All) {
          stageWithDealTypes.forecast.All = [];
        }
        stageWithDealTypes[itemStage].All.push(item.owner_id);
        stageWithDealTypes.forecast.All.push(item.owner_id);
      });
    });

    each(stageWithDealTypes, (stageWithDealType) => {
      each(stageWithDealType, (ownerIds, type) => {
        stageWithDealType[type] = uniq(ownerIds).length;
      });
    });

    stageWithDealTypes = reduce(stageWithDealTypes, (results, stageWithDealType, stage) => {
      let found = false;
      const stats = reduce(stageWithDealType, (r, count, type) => {
        if (count) {
          found = true;
          r[type] = count;
        }
        return r;
      }, {});
      if (found) {
        results[stage] = stats;
      }
      return results;
    }, {});

    const qualifiedStages = filter(stageWithDealTypes, (stageWithDealType) => {
      const atLeast2 = filter(stageWithDealType, c => (c > 1));
      return atLeast2.length;
    });
    // const hasData = qualifiedStages.length === 3; // 3 stages!
    const hasData = qualifiedStages.length > 0; // /issues/308
    // all
    each(stageWithDealTypes, (stageWithDealType) => {
      const allKeys = keys(stageWithDealType);
      if (allKeys.length > 1) {
        let s = 0;
        each(stageWithDealType, (v) => {
          s += v;
        });
        stageWithDealType.All = s;
      }
    });
    this.setState({ stageWithDealTypes, hasData }, () => {
      this.updateDealTypeByStage();
    });
    
  }

  toggleDealType(dealType) {
    this.context.updateUserPreference(USER_PREFERENCE_DEAL_TYPE, dealType);
    this.setState({ dealType });
  }

  toggleStatType(statType) {
    this.setState({ statType });
    this.context.updateUserPreference(USER_PREFERENCE_REPORT_TYPE, statType);
  }

  toggleStage(stage) {
    this.context.updateUserPreference(USER_PREFERENCE_RATE_TYPE, stage);
    this.setState({ stage }, () => {
      this.updateDealTypeByStage();
    });
  }

  updateDealTypeByStage() {
    const { dealType, stageWithDealTypes, stage } = this.state;
    if (stageWithDealTypes[stage]) {
      const validDealTypes = this.getOrderTypes();
      if (!dealType || (dealType && !stageWithDealTypes[stage][dealType])) {
        const defaultDealType = validDealTypes.find(type => stageWithDealTypes[stage][type]);
        this.toggleDealType(defaultDealType);
      }
    } else {
      this.toggleDealType(null);
    }
  }

  handleShowTooltip(event) {
    const showTooltip = event.target.checked;
    this.setState({ showTooltip });
    this.context.updateUserPreference(USER_PREFERENCE_SHOW_TIP, showTooltip);
  }

  handleIsFixedQuarants(event) {
    const isFixed = event.target.checked;
    this.setState({ isFixed });
    this.context.updateUserPreference(USER_PREFERENCE_IS_FIXED, isFixed);
  }

  balanceArray(input, middleIndex) {
    if (middleIndex < 0 || middleIndex >= input.length) {
      return input;
    }
    const lowerHalf = slice(input, 0, middleIndex);
    const upperHalf = slice(input, middleIndex + 1);
    const pad = Math.max(lowerHalf.length, upperHalf.length);
    const averageValue = input[middleIndex];

    while (lowerHalf.length < pad) {
      lowerHalf.splice(1, 0, null);
    }

    const firstUpper = upperHalf.length ? upperHalf[0] : null;
    let upperIncr = (pad - upperHalf.length) + 1;
    const upperStep = firstUpper !== null ? (firstUpper - averageValue) / upperIncr : null;
    while (upperHalf.length < pad) {
      upperIncr -= 1;
      upperHalf.splice(0, 0, upperStep !== null ? averageValue + (upperStep * upperIncr) : null);
    }

    return lowerHalf.concat([averageValue]).concat(upperHalf);
  }

  renderControl() {
    const {
      stage, dealType, stageWithDealTypes, statType,
    } = this.state;
    const {
      saleReps, hasDealTypeSetup, forecastClosedMonths,
    } = this.props;
    const total = saleReps.length;
    let stageButtons = [];
    let typeButtons = [];
    const stages = [
      { value: 'Won', label: 'Win Rate' },
      { value: 'Lost', label: 'Loss Rate' },
      { value: 'No Decision', label: 'No Decision Rate' },
    ];
    if (forecastClosedMonths > 0) {
      stages.push({ value: 'forecast', label: 'Forecast Accuracy' });
    }
    if (total > 0) {
      let activeStageButtonLabel = 'All';
      let activeTypeButtonLabel = 'All';
      each(stages, (stg) => {
        const s = stg.value;
        if (stageWithDealTypes[s]) {
          const types = this.getOrderTypes();
          const l = stg.label;
          const active = s === stage;
          if (active) {
            activeStageButtonLabel = l;
            each(types, (type) => {
              if (stageWithDealTypes[s][type]) {
                const activeType = type === dealType;
                if (activeType) {
                  activeTypeButtonLabel = type === 'All' ? 'All opportunities' : type;
                }
                typeButtons.push((
                  <MenuItem key={type} active={activeType} onSelect={() => { this.toggleDealType(type); }}>
                    {(type === 'All' ? 'All opportunities' : type)}
                  </MenuItem>
                ));
              }
            });
          }
          if (s === 'forecast') {
            stageButtons.push(<MenuItem key="div" divider />);
          }
          stageButtons.push(<MenuItem key={s} active={active} onSelect={() => { this.toggleStage(s); }}>{l}</MenuItem>);
        }
      });

      stageButtons = (
        <Dropdown
          id="performance-stage-dropdown"
        >
          <Dropdown.Toggle bsSize="small">
            {activeStageButtonLabel}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {stageButtons}
          </Dropdown.Menu>
        </Dropdown>
      );
      typeButtons = typeButtons.length > 1 && hasDealTypeSetup ? (
        <Dropdown
          id="performance-type-dropdown"
        >
          <Dropdown.Toggle bsSize="small">
            {activeTypeButtonLabel}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {typeButtons}
          </Dropdown.Menu>
        </Dropdown>
      ) : <button className="btn btn-default btn-sm">all opportunities</button>;
    }

    return (
      <div>
        {total > 0 &&
          <h5 className="clearfix sub-header-with-controls">
            <div className="pull-right text-right">
              {this.renderBottomControl()}
            </div>
            <div className="pull-left">
              Evaluate&nbsp;
              {stageButtons}
              &nbsp;performance of &nbsp;
              {typeButtons}
              &nbsp;by opportunity&nbsp;
              <Dropdown
                id="performance-count-dropdown"
              >
                <Dropdown.Toggle bsSize="small">
                  {statType}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem
                    active={statType === 'amount'}
                    onSelect={() => { this.toggleStatType('amount'); }}
                  >
                    Amount
                  </MenuItem>
                  <MenuItem
                    active={statType === 'count'}
                    onSelect={() => { this.toggleStatType('count'); }}
                  >
                    Count
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </h5>
        }
      </div>
    );
  }

  renderBottomControl() {
    const { showTooltip, isFixed } = this.state;
    return (
      <div className="clearfix">
        <div className="pull-left">
          <label key="isFixed" htmlFor="show-is-fixed" className={`checkbox ${isFixed ? 'text-active' : ''}`} style={{ margin: 0, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={isFixed}
              value="true"
              id="show-is-fixed"
              onChange={this.handleIsFixedQuarants}
            /> Fixed Quadrants
          </label>
        </div>
        <div className="pull-left" style={{ marginLeft: '40px' }}>
          <label key="tooltip" htmlFor="show-quadrant-tip" className={`checkbox ${showTooltip ? 'text-active' : ''}`} style={{ margin: 0, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={showTooltip}
              value="true"
              id="show-quadrant-tip"
              onChange={this.handleShowTooltip}
            /> Tooltip
          </label>
        </div>
      </div>
    );
  }

  renderQuadrant(quadrant, totalReps) {
    const totalItems = quadrant.items;
    const percentage = totalReps !== 0 ? (totalItems / totalReps) * 100.00 : 0;
    const popovers = (
      <Tooltip id={`quadrant-${quadrant.order}`} title={quadrant.title}>
        {quadrant.tooltip}
      </Tooltip>
    );
    let placement = 'top';
    if (quadrant.order === 0) {
      placement = 'right';
    } else if (quadrant.order === 3) {
      placement = 'left';
    }
    return (
      <div>
        <strong><NumberDisplay value={totalItems} precision={0} /></strong>
        &nbsp;
        <span style={{ color: quadrant.color }}>{quadrant.title}</span>
        &nbsp;
        <span className="text-muted">(<NumberDisplay value={percentage} precision={0} suffix="%" />)</span>
        &nbsp;
        <OverlayTrigger trigger={['hover', 'focus']} placement={placement} overlay={popovers}>
          <Fa className="text-active" name="info-circle" />
        </OverlayTrigger>
      </div>
    );
  }

  renderAlert(attentionReps, attentionAmount, attentionCount) {
    const { dealType, stage } = this.state;
    if (attentionReps === 0) {
      return null;
    }
    const popovers = (
      <Tooltip id="quadrant-tooltip" title="Improvement Opportunity">Represents the sum and count of opportunities that were lost in the highlighted quadrants.</Tooltip>
    );
    // $XX.XK of [dealTypeLabel] [lostLabel] by XX sales reps in XX opportunities.
    let dealTypeLabel = dealType;
    if (dealType === 'Renewal') {
      dealTypeLabel = 'renewals';
    } else if (dealType === 'New business') {
      dealTypeLabel = 'new business';
    } else if (dealType === 'Add-on') {
      dealTypeLabel = 'add-on business';
    } else if (dealType === 'Upsell') {
      dealTypeLabel = 'upsell business';
    } else if (dealType === 'All') {
      dealTypeLabel = '';
    }
    const lostLabel = stage === 'No Decision' ? 'lost to no decision' : 'lost';

    const salerepLabel = attentionReps === 1 ? 'sales rep' : 'sales reps';
    const opportunityLabel = attentionCount === 1 ? 'opportunity' : 'opportunities';
    const lostSuffix = stage !== 'No Decision' && dealType === 'All' ? opportunityLabel : '';
    const ofLabel = stage === 'No Decision' && dealType === 'All' ? '' : 'of';
    return (
      <div>
        <div className={`${styles.warning} panel panel-default text-center animated flash`}>
          <div className="panel-body">
            <Fa name="exclamation-circle" /> <strong>Improvement Opportunity:</strong>&nbsp;
            <strong><MoneyDisplay value={attentionAmount} abbreviated precision={1} /></strong> {ofLabel} {dealTypeLabel} {lostLabel} {lostSuffix}
            &nbsp;by&nbsp;
            <strong><NumberDisplay value={attentionReps} precision={0} /></strong> {salerepLabel}
            &nbsp;in&nbsp;
            <strong><NumberDisplay value={attentionCount} precision={0} /></strong> {opportunityLabel}.
          </div>
          <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={popovers}>
            <i className={`${styles.tipTrigger} animated fadeIn`}><Fa name="ellipsis-h" /></i>
          </OverlayTrigger>
        </div>
      </div>
    );
  }

  renderGraph() {
    const {
      saleReps, organization, forecastKey, isFontSizeBig,
    } = this.props;
    const {
      stage, dealType, statType, showTooltip, periodLabel, forecastMappingLabels,
      isFixed,
    } = this.state;
    const { store } = this.context;
    const forecastStatus = `$${forecastKey}Status`;
    const forecastValue = `${forecastKey}Forecast`;

    const points = [];
    let allXPoints = [];
    let allYPoints = [];
    const isCountStat = statType === 'count';
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }

    let grandCount = 0;
    let grandAmount = 0;
    let grandForecast = 0;
    let grandAverageAmount = 0;
    let grandAverageRate = 0;
    each(saleReps, (saleRep) => {
      const items = [];
      let amounts = 0; // across all stages with same dealtype
      let counts = 0; // across all stages with same dealtype
      let amount = 0; // same stage, same deal
      let count = 0; // same stage, same deal
      let alertCount = 0;
      let alertAmount = 0;
      each(saleRep.items, (item) => {
        if (indexOf(item.types, dealType) >= 0 || dealType === 'All') {
          amounts += item.amount || 0;
          counts += 1;
          if (stage === 'No Decision') {
            if (item.stage === stage) {
              alertCount += 1;
              alertAmount += item.amount || 0;
            }
          } else if (item.stage === 'Lost') {
            alertCount += 1;
            alertAmount += item.amount || 0;
          }
          if (item.stage === stage) {
            amount += item.amount || 0;
            count += 1;
            items.push(item);
          } else if (stage === 'forecast' && item.stage === 'Won') {
            amount += item.amount || 0;
            count += 1;
            items.push(item);
          }
        }
      });
      if (items.length) {
        const amountRate = amounts !== 0 ? (amount / amounts) * 100 : 0;
        const countRate = counts !== 0 ? (count / counts) * 100 : 0;
        allXPoints.push(isCountStat ? count : amount);
        const forecast = (saleRep[forecastValue] || 0) * 100;
        if (stage === 'forecast') {
          allYPoints.push(forecast);
        } else {
          allYPoints.push(isCountStat ? countRate : amountRate);
        }

        points.push({
          ...saleRep,
          items,
          amount,
          count,
          forecast,
          alertCount,
          alertAmount,
          amountRate,
          countRate,
        });
        grandCount += count;
        grandAmount += amount;
        grandAverageAmount += count ? amount / count : 0;
        grandForecast += saleRep[forecastValue] || 0;
        grandAverageRate += isCountStat ? countRate : amountRate;
      }
    });
    allXPoints = uniq(allXPoints);
    allYPoints = uniq(allYPoints);

    const averageX = this.getAverage(allXPoints);
    const averageY = this.getAverage(allYPoints);
    if (indexOf(allYPoints, averageY) < 0) {
      allYPoints.push(averageY);
    }
    each([0, 100], (point) => {
      if (indexOf(allYPoints, point) < 0) {
        allYPoints.push(point);
      }
    });

    if (indexOf(allXPoints, averageX) < 0) {
      allXPoints.push(averageX);
    }
    allXPoints = allXPoints.sort((a, b) => (a - b));
    const minX = allXPoints.length ? allXPoints[0] : 0;
    const maxX = allXPoints.length ? allXPoints[allXPoints.length - 1] : 0;

    const xAxisMin = minX;
    const xAxisMax = maxX;

    const minXValue = isCountStat ? Math.max(0, minX - 1) : 0.9 * minX;
    const maxXValue = isCountStat ? maxX + 1 : 1.1 * maxX;

    each([minXValue, maxXValue], (point) => {
      if (indexOf(allXPoints, point) < 0) {
        allXPoints.push(point);
      }
    });
    allXPoints = allXPoints.sort((a, b) => (a - b));
    allYPoints = allYPoints.sort((a, b) => (a - b));
    const averageXIndex = indexOf(allXPoints, averageX);
    const averageYIndex = indexOf(allYPoints, averageY);
    allXPoints = this.balanceArray(allXPoints, averageXIndex);
    allYPoints = this.balanceArray(allYPoints, averageYIndex);

    const finalAverageXIndex = indexOf(allXPoints, averageX);
    const finalAverageYIndex = indexOf(allYPoints, averageY);
    const quadrants = [
      {
        id: 1, items: 0, amount: 0, count: 0, title: '', color: '', order: 0, alertCount: 0, alertAmount: 0, tooltip: '', x: 0, y: 0,
      },
      {
        id: 2, items: 0, amount: 0, count: 0, title: '', color: '', order: 0, alertCount: 0, alertAmount: 0, tooltip: '', x: 0, y: 0,
      },
      {
        id: 3, items: 0, amount: 0, count: 0, title: '', color: '', order: 0, alertCount: 0, alertAmount: 0, tooltip: '', x: 0, y: 0,
      },
      {
        id: 4, items: 0, amount: 0, count: 0, title: '', color: '', order: 0, alertCount: 0, alertAmount: 0, tooltip: '', x: 0, y: 0,
      },
    ];
    // #0C7CD5
    const rgbColor = stage === 'forecast' ? '12,124,213' : getColorFromKey(stage, true);
    const series = [{
      color: `rgba(${rgbColor},.7)`,
      marker: {
        radius: isFontSizeBig ? 6 : 5,
        symbol: 'circle',
      },
      data: points.map((point) => {
        const dx = isCountStat ? point.count : point.amount;
        const x = indexOf(allXPoints, dx);

        let dy = 'countRate';
        if (stage === 'forecast') {
          dy = 'forecast';
        } else {
          dy = isCountStat ? 'countRate' : 'amountRate';
        }
        const y = indexOf(allYPoints, point[dy] || null);

        let index = null;
        if (x < finalAverageXIndex) {
          // 0 or 2
          index = (y < finalAverageYIndex) ? 2 : 0;
        } else {
          // 1 or 3
          index = (y < finalAverageYIndex) ? 3 : 1;
        }
        if (index !== null) {
          quadrants[index].amount += point.amounts;
          quadrants[index].counts += point.count;
          quadrants[index].items += 1;
          quadrants[index].alertCount += point.alertCount;
          quadrants[index].alertAmount += point.alertAmount;
        }
        return {
          ...point,
          x: isFixed ? x : dx,
          y: isFixed ? y : point[dy],
          events: {
            click: (event) => {
              if (event.point.options.owner && event.point.options.owner.user_id) {
                this.props.onChartSegmentSelect([event.point.options.owner.user_id], this.state.period, this.state.forecastCategoryParams);
              }
            },
          },
        };
      }),
    }];
    const highlightColor = `rgba(${rgbColor},0.1)`;
    const highlightedQuarants = filter(quadrants, (quadrant, index) => {
      if (stage === 'Won') {
        return index === 2 || index === 3;
      }
      return index === 0 || index === 1 || index === 3;
    });

    let attentionReps = 0;
    let attentionAmount = 0;
    let attentionCount = 0;
    each(highlightedQuarants, (highlightedQuarant) => {
      attentionReps += highlightedQuarant.items;
      attentionCount += highlightedQuarant.alertCount;
      attentionAmount += highlightedQuarant.alertAmount;
    });

    if (stage === 'Won' || stage === 'forecast') {
      series.unshift({
        name: 'Bottom',
        type: 'polygon',
        color: highlightColor,
        enableMouseTracking: false,
        data: [
          [isFixed ? 0 : xAxisMin, 0],
          [isFixed ? allXPoints.length - 1 : xAxisMax, 0],
          [isFixed ? allXPoints.length - 1 : xAxisMax, isFixed ? finalAverageYIndex : averageY],
          [isFixed ? 0 : xAxisMin, isFixed ? finalAverageYIndex : averageY],
        ],
      });
      const rateText = stage === 'Won' ? 'win rates' : 'forecast accuracy';
      quadrants[0].title = 'Learners';
      quadrants[0].color = '#82d785';
      quadrants[0].order = 2;
      quadrants[0].tooltip = `Reps with below average win ${statType}s, but above average ${rateText}.`;

      quadrants[1].title = 'Leaders';
      quadrants[1].color = '#4caf50';
      quadrants[1].order = 3;
      quadrants[1].tooltip = `Reps with above average ${rateText} and above average win ${statType}s.`;

      quadrants[2].title = 'Laggards';
      quadrants[2].color = '#e51c23';
      quadrants[2].order = 0;
      quadrants[2].tooltip = `Reps with below average ${rateText} and below average win ${statType}s.`;

      quadrants[3].title = 'Borderline';
      quadrants[3].color = '#ff9800';
      quadrants[3].order = 1;
      quadrants[3].tooltip = `Reps with below average ${rateText}, but above average win ${statType}s.`;
    } else {
      series.unshift({
        name: 'Top',
        type: 'polygon',
        color: highlightColor,
        enableMouseTracking: false,
        data: [
          [isFixed ? 0 : xAxisMin, isFixed ? finalAverageYIndex : averageY],
          [isFixed ? allXPoints.length - 1 : xAxisMax, isFixed ? finalAverageYIndex : averageY],
          [isFixed ? allXPoints.length - 1 : xAxisMax, isFixed ? allYPoints.length - 1 : 100],
          [isFixed ? 0 : xAxisMin, isFixed ? allYPoints.length - 1 : 100],
        ],
      });
      series.unshift({
        name: 'Bottom',
        type: 'polygon',
        color: highlightColor,
        // color: 'rgba(255, 0, 0, .2)',
        enableMouseTracking: false,
        data: [
          [isFixed ? finalAverageXIndex : averageX, 0],
          [isFixed ? allXPoints.length - 1 : xAxisMax, 0],
          [isFixed ? allXPoints.length - 1 : xAxisMax, isFixed ? finalAverageYIndex : averageY],
          [isFixed ? finalAverageXIndex : averageX, isFixed ? finalAverageYIndex : averageY],
        ],
      });

      const tipType = stage === 'Lost' ? 'loss' : 'no decision';

      quadrants[0].title = 'Learners';
      quadrants[0].color = '#82d785';
      quadrants[0].order = 2;
      quadrants[0].tooltip = `Reps with below average ${tipType} ${statType}s, but above average ${tipType} rates.`;

      quadrants[1].title = 'Laggards';
      quadrants[1].color = '#e51c23';
      quadrants[1].order = 0;
      quadrants[1].tooltip = `Reps with above average ${tipType} rates and above average ${tipType} ${statType}s.`;

      quadrants[2].title = 'Leaders';
      quadrants[2].color = '#4caf50';
      quadrants[2].order = 3;
      quadrants[2].tooltip = `Reps with below average ${tipType} rates and below average ${tipType} ${statType}s.`;

      quadrants[3].title = 'Borderline';
      quadrants[3].color = '#ff9800';
      quadrants[3].order = 2;
      quadrants[3].tooltip = `Reps with above average ${tipType} ${statType}s, but below average ${tipType} rates.`;
    }

    quadrants[0].x = isFixed ? (finalAverageXIndex - 0) / 2 : minX + ((averageX - minX) / 2);
    quadrants[0].y = isFixed ? finalAverageYIndex + Math.floor((allYPoints.length - finalAverageYIndex) / 2) : averageY + ((100 - averageY) / 2);

    quadrants[1].x = isFixed ? finalAverageXIndex + Math.floor((finalAverageXIndex - 0) / 2) : averageX + ((maxX - averageX) / 2);
    quadrants[1].y = isFixed ? finalAverageYIndex + Math.floor((allYPoints.length - finalAverageYIndex) / 2) : averageY + ((100 - averageY) / 2);

    quadrants[2].x = isFixed ? (finalAverageXIndex - 0) / 2 : minX + ((averageX - minX) / 2);
    quadrants[2].y = isFixed ? Math.floor((finalAverageYIndex - 0) / 2) : (averageY - 0) / 2;

    quadrants[3].x = isFixed ? finalAverageXIndex + Math.floor((finalAverageXIndex - 0) / 2) : averageX + ((maxX - averageX) / 2);
    quadrants[3].y = isFixed ? Math.floor((finalAverageYIndex - 0) / 2) : (averageY - 0) / 2;

    const xTitlePrefix = isCountStat ? 'Count' : 'Amount';
    let xTitle = xTitlePrefix;
    if (stage === 'Won' || stage === 'forecast') {
      xTitle = `${xTitlePrefix} Won`;
    } else if (stage === 'Lost') {
      xTitle = `${xTitlePrefix} Lost to Competitors`;
    } else if (stage === 'No Decision') {
      xTitle = `${xTitlePrefix} Lost to No Decisions`;
    }
    if (!isCountStat && suffix && suffix.length) {
      xTitle += ` (${suffix})`;
    }
    const config = {
      chart: {
        type: 'scatter',
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'transparent',
        height: isFontSizeBig ? 600 : 400,
      },
      title: {
        text: null,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        title: {
          text: xTitle,
          style: {
            fontWeight: 'bold',
            fontSize: isFontSizeBig ? '16px' : null,
          },
        },
        lineWidth: 1,
        gridLineColor: 'transparent',
        ...(isFixed ? {
          min: 0,
          minRange: 1,
          max: allXPoints.length - 1,
          allowDecimals: false,
          startOnTick: true,
          showFirstLabel: true,
          endOnTick: true,
          showLastLabel: true,
        } : {
          min: xAxisMin,
          max: xAxisMax,
          startOnTick: true,
          endOnTick: true,
          allowDecimals: !isCountStat,
        }),

        labels: {
          style: {
            color: 'rgba(0, 0, 0, .8)',
            fontSize: isFontSizeBig ? '16px' : null,
          },
          ...(isFixed ? {
            formatter: function formatter() {
              const v = allXPoints[this.value];
              if (v === 0) {
                return 0;
              } else if (v === null || v === undefined) {
                return null;
              }
              if (isCountStat) {
                return numeral(v).format('0');
              }
              return formatMoney(v, true, 1, symbol);
            },
          } : {
            formatter: function formatter() {
              if (isCountStat) {
                return numeral(this.value).format('0');
              }
              return formatMoney(this.value, true, 1, symbol);
            },
          }),
        },

        tickColor: 'rgba(66, 66, 66, 0.5)',
        plotLines: [{
          value: isFixed ? finalAverageXIndex : averageX,
          dashStyle: 'solid',
          color: 'rgba(0, 0, 0, 1)',
          width: 1,
          zIndex: 3,
          dataLabels: {
            enabled: true,
          },
          label: {
            text: null,
            enabled: true,
            align: 'center',
            verticalAlign: 'top',
            rotation: 0,
            style: {
              color: '#333333',
            },
            formatter: function formatter() {
              return this.value;
            },
          },
        }],
      },
      yAxis: {
        title: {
          text: this.getLabel(stage, 'Rate'),
          style: {
            fontWeight: 'bold',
            fontSize: isFontSizeBig ? '16px' : null,
          },
        },
        ...(isFixed ? {
          min: 0,
          max: allYPoints.length - 1,
          allowDecimals: false, // important
          minRange: 1,
        } : {
          min: 0,
          max: 100,
          allowDecimals: true,
        }),
        labels: {
          style: {
            color: 'rgba(0, 0, 0, .8)',
            fontSize: isFontSizeBig ? '16px' : null,
          },
          ...(isFixed ? {
            formatter: function formatter() {
              const v = allYPoints[this.value];
              if (v === 0) {
                return 0;
              } else if (v === null || v === undefined) {
                return null;
              }
              return `${numeral(v).format('0.00')}%`;
            },
          } : {
            formatter: function formatter() {
              return `${numeral(this.value).format('0')}%`;
            },
          }),
        },

        startOnTick: true,
        showFirstLabel: true,
        endOnTick: true,
        showLastLabel: true,

        plotLines: [{
          value: isFixed ? finalAverageYIndex : averageY,
          dashStyle: 'solid',
          color: 'rgba(0, 0, 0, 1)',
          width: 1,
          label: {
            text: null,
            align: 'center',
            verticalAlign: 'middle',
            style: {
              color: '#333333',
            },
          },
        }],
        lineWidth: 1,
        gridLineColor: 'transparent',
        tickColor: 'rgba(66, 66, 66, 0.5)',
        crosshair: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: showTooltip,
        formatter: function formatter() {
          const { owner } = this.point.options;
          const iAmount = this.point.options.amount;
          const iCount = this.point.options.count;
          const amount = formatMoney(iAmount, true, 1, symbol, suffix);
          const count = numeral(iCount).format('0');
          const percentage = numeral(isCountStat ? this.point.options.countRate : this.point.options.amountRate).format('0.0');
          const avgAmount = iCount ? iAmount / iCount : 0;
          const avgAmountStr = formatMoney(avgAmount, true, 1, symbol, suffix);

          // gaps:
          const reverseBg = stage !== 'Won' && stage !== 'forecast';

          const totalSalesReps = points.length;

          const averageCount = totalSalesReps !== 0 ? grandCount / totalSalesReps : 0;
          const countGap = averageCount ? ((iCount - averageCount) / averageCount) * 100 : 0;
          const countGapStr = formatGap(countGap, reverseBg);

          const averageAmount = totalSalesReps !== 0 ? grandAmount / totalSalesReps : 0;
          const amountGap = averageAmount ? ((iAmount - averageAmount) / averageAmount) * 100 : 0;
          const amountGapStr = formatGap(amountGap, reverseBg);

          const averageRate = totalSalesReps !== 0 ? grandAverageRate / totalSalesReps : 0;
          const rateGap = averageRate ? (((isCountStat ? this.point.options.countRate : this.point.options.amountRate) - averageRate) / averageRate) * 100 : 0;
          const rateGapStr = formatGap(rateGap, reverseBg);

          const averageTotalAmount = totalSalesReps !== 0 ? grandAverageAmount / totalSalesReps : 0;
          const totalAmountGap = averageTotalAmount ? ((avgAmount - averageTotalAmount) / averageTotalAmount) * 100 : 0;
          const totalAmountGapStr = formatGap(totalAmountGap, reverseBg);

          const forecast = this.point.options[forecastValue] || 0;
          const forecastLoaded = this.point.options[forecastStatus] === 'loaded';
          const forecastStr = numeral(forecast * 100).format('0.0');
          const averageForecast = totalSalesReps !== 0 ? grandForecast / totalSalesReps : 0;
          const forecastGap = averageForecast ? (forecast - averageForecast) / averageForecast : 0;
          const forecastGapStr = formatGap(forecastGap * 100);

          let ownerHtml = '';
          if (owner) {
            // const div = document.createElement('div');
            // ReactDOM.render(<Provider store={store}><OwnerCell showEmail={false} showPhone={false} isTooltip owner={owner} /></Provider>, div);
            const sfRole = owner.role && owner.role.name ? owner.role : null;
            let role = '';
            if (sfRole !== null && sfRole.name) {
              role = `<div>${sfRole.name}</div>`;
            }
            ownerHtml = `
              <div><h4>${(owner.name || owner.display_name)}</h4>${role}</div>
            `;
          }
          let lblDeals = 'Deals';
          let lblAmount = 'Amount';
          let lblRate = 'Rate';
          let lblAvg = 'Avg Amount';
          if (stage === 'Won' || stage === 'forecast') {
            lblDeals = 'Won Deals';
            lblAmount = 'Won Amount';
            lblRate = 'Win Rate';
            lblAvg = 'Avg Won Amount';
          } else if (stage === 'Lost') {
            lblDeals = 'Lost Deals';
            lblAmount = 'Lost Amount';
            lblRate = 'Loss Rate';
            lblAvg = 'Avg Loss Amount';
          } else {
            lblDeals = `${stage}s`;
            lblAmount = `${stage} Amount`;
            lblRate = `${stage} Rate`;
            lblAvg = `Avg ${stage} Amount`;
          }

          let forecastRow = '';
          const tfoots = [];
          if (forecastLoaded) {
            forecastRow = `<tr>
              <td>Forecast Accuracy<sup class="text-active">1</sup></td>
              <td class="text-right">${forecastStr}%</td>
              <td class="text-right">${forecastGapStr}</td>
            </tr>`;
            let forecasts = '';
            if (forecastMappingLabels) {
              forecasts = forecastMappingLabels.join(' + ');
            }
            tfoots.push(`<p>
              <small>
                <sup class="text-active">1</sup> Forecast accuracy percentage is the rep&rsquo;s average<br />
                forecast accuracy based on their historical forecasts.<br />
              </small>
            </p>`);
          }
          tfoots.push(`<p>
            <small>
              <sup class="text-active">2</sup> Gap is the percentage size of the performance gap<br />
              compared to the average for all reps in the data set
            </small>
          </p>`);

          return `${ownerHtml}<table class="table table-condensed ${styles.tipTable}">
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th class="text-right">Gap<sup class="text-active">2</sup></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${lblDeals}</td>
                <td class="text-right">${count}</td>
                <td class="text-right">${countGapStr}</td>
              </tr>
              <tr>
                <td>${lblAmount}</td>
                <td class="text-right">${amount}</td>
                <td class="text-right">${amountGapStr}</td>
              </tr>
              <tr>
                <td>${lblRate}</td>
                <td class="text-right">${percentage}%</td>
                <td class="text-right">${rateGapStr}</td>
              </tr>
              <tr>
                <td>${lblAvg}</td>
                <td class="text-right">${avgAmountStr}</td>
                <td class="text-right">${totalAmountGapStr}</td>
              </tr>
              ${forecastRow}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3">
                  ${tfoots.join('')}
                </td>
              </tr>
            </tfoot>
          </table>`;
        },
        useHTML: true,
        zIndex: 10000,
        backgroundColor: 'rgba(0,0,0, 0.75)',
        style: {
          color: 'rgba(255, 255, 255, 0.75)',
        },
      },
      plotOptions: {
        series: {
          events: {
            afterAnimate: function afterAnimate() {
              const fontSize = isFontSizeBig ? '18px' : '12px';
              const fontWeight = 'bold';

              const { chart } = this;
              const [xAxis] = chart.xAxis;
              const [yAxis] = chart.yAxis;

              each(quadrants, (quadrant, i) => {
                if (quadrant.x && quadrant.y) {
                  const pxVal = xAxis.toPixels(quadrant.x);
                  const pyVal = yAxis.toPixels(quadrant.y);
                  const label = chart.renderer.text(quadrant.title, pxVal, pyVal, true, false);
                  label.css({
                    fontSize,
                    fontWeight,
                    color: '#ffffff',
                    backgroundColor: quadrant.color,
                    padding: '3px 5px',
                    borderRadius: '3px',
                    zIndex: -1,
                  });
                  label.add();
                }
              });
            },
          },
        },
        scatter: {
          marker: {
            radius: 5,
            states: {
              hover: {
                enabled: true,
                lineColor: 'rgb(100,100,100)',
              },
            },
          },
          states: {
            hover: {
              marker: {
                enabled: false,
              },
            },
          },
        },
      },
      series,
    };

    let averageText = `Average ${stage === 'No Decision' ? 'Lost to ' : ''}`;
    if (stage === 'forecast') {
      averageText += 'Won';
    } else {
      averageText += stage;
    }

    return (
      <div>
        {this.renderAlert(attentionReps, attentionAmount, attentionCount)}
        <div className={styles.graphInner}>
          <ReactHighcharts config={config} />
        </div>
        <div>
          <div className={`panel panel-default ${styles.quadrantSummary}`}>
            <div className="panel-body">
              <table className="table table-condensed">
                <tbody>
                  <tr>
                    {sortBy(quadrants, 'order').map(quadrant => (
                      <td key={quadrant.id} className="text-center">
                        {this.renderQuadrant(quadrant, points.length)}
                      </td>
                      ))}
                  </tr>
                </tbody>
              </table>
              <div className={styles.lines}>
                {sortBy(quadrants, 'order').map((quadrant) => {
                  const totalItems = quadrant.items;
                  const percentage = points.length !== 0 ? (totalItems / points.length) * 100.00 : 0;
                  return (
                    <span key={quadrant.id} style={{ width: `${percentage}%`, background: quadrant.color }} />
                  );
                })}
              </div>
            </div>
          </div>
          <div className="text-center">
            Average {this.getLabel(stage, 'Rate')}:&nbsp;
            <strong><NumberDisplay value={allYPoints[finalAverageYIndex]} precision={1} suffix="%" /></strong>
            <span>&nbsp;&bull;&nbsp;</span>
            {averageText}:&nbsp;
            {isCountStat && <strong><NumberDisplay value={allXPoints[finalAverageXIndex]} precision={2} /></strong>}
            {!isCountStat && <strong><MoneyDisplay value={allXPoints[finalAverageXIndex]} precision={1} abbreviated /></strong>}
          </div>
        </div>
      </div>
    );
  }

  renderWarning() {
    return (
      <div className="alert alert-warning">
        In order to display this view the data set needs to include at
        least two active sales reps with at least 3 closed opportunities for the opportunity type selected.
        You are seeing this because the current data set does not meet these minimum requirements.
      </div>
    );
  }

  render() {
    const { loaded, displayForecastData } = this.props;
    const {
      hasData, stage, dealType, stageWithDealTypes, loadingForecast,
    } = this.state;
    if (!loaded) {
      return null;
    }
    if (!hasData) {
      return null;
    }

    const showWarning = stageWithDealTypes[stage] && stageWithDealTypes[stage][dealType] <= 1;
    const loading = loadingForecast && displayForecastData;

    return (
      <div className={`${styles.graph} animated fadeIn`}>
        <div className={styles.graphWrapper}>
          {this.renderControl()}
          {!showWarning &&
            <div>
              {!loading && this.renderGraph()}
              {loading && <div><ProgressBar /></div>}
            </div>
          }
          {showWarning && this.renderWarning()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    saleReps: getSaleReps(state),
    loaded: getLoaded(state),
    hasDealTypeSetup: getHasDealTypeSetup(state),
    organization: getUserCurrentOrganization(state),
    isFontSizeBig: getIsFontSizeBig(state),
  };
}
Quadrant.propTypes = {
  dispatch: PropTypes.func.isRequired,
  saleReps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loaded: PropTypes.bool.isRequired,
  hasDealTypeSetup: PropTypes.bool.isRequired,
  organization: PropTypes.shape({}),
  onChartSegmentSelect: PropTypes.func,
  forecastClosedMonths: PropTypes.number.isRequired,
  minForecastDate: PropTypes.string,
  maxForecastDate: PropTypes.string,
  criteria: PropTypes.shape({}),
  displayForecastData: PropTypes.bool,
  forecastKey: PropTypes.string,
  isFontSizeBig: PropTypes.bool.isRequired,
};
Quadrant.defaultProps = {
  organization: null,
  criteria: null,
  minForecastDate: null,
  maxForecastDate: null,
  onChartSegmentSelect: () => {},
  displayForecastData: false,
  forecastKey: 'forecast',
};
Quadrant.contextTypes = {
  store: PropTypes.object,
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(Quadrant);
